module.exports = {
  en: {
    'HRMS41EC1': {
      '10': 'Interview Date',
      '20': 'To',
      '30': 'Application No.',
      '40': 'To',
      '50': 'Interview Date',
      '60': 'Time',
      '70': 'Application No.',
      '80': 'Applicant Name',
      '90': 'Position',
      '100': 'Status'
    },
    'HRMS41EC2': {
      '10': 'Application No.',
      '20': 'Interview Date',
      '30': 'Code of Interview Form',
      '40': 'Interview Form',
      '50': 'Result of Interview',
      '60': 'Result of Interview',
      '70': 'History of Interview',
      '80': 'Weight',
      '90': 'Score',
      '95': 'From',
      '100': 'Interview Date',
      '110': 'Interview By',
      '120': 'Status of Interview',
      '130': 'Remark',
      '140': 'Comment',
      '150': 'Pending the interview',
      '160': 'Interview Complete'
    },
    'HRMS41EC3': {
      '10': 'Application No.',
      '20': 'History of Interview',
      '30': 'No',
      '40': 'Approval number',
      '50': 'Position',
      '60': 'Interview Date',
      '70': 'Status',
      '80': 'Interview By',
      '90': 'Interview Date'
    }
  },
  th: {
    'HRMS41EC1': {
      '10': 'วันที่สัมภาษณ์',
      '20': 'ถึงวันที่',
      '30': 'เลขที่ใบสมัคร',
      '40': 'ถึง',
      '50': 'วันที่สัมภาษณ์',
      '60': 'เวลา',
      '70': 'เลขที่ใบสมัคร',
      '80': 'ชื่อผู้สมัคร',
      '90': 'ตำแหน่ง',
      '100': 'สถานะ'
    },
    'HRMS41EC2': {
      '10': 'เลขที่ใบสมัคร',
      '20': 'วันที่สัมภาษณ์',
      '30': 'รหัสแบบฟอร์ม',
      '40': 'แบบประเมิน',
      '50': 'ผลการประเมิน',
      '60': 'ผลการสอบสัมภาษณ์',
      '70': 'ประวัติการเรียกสัมภาษณ์',
      '80': 'น้ำหนัก',
      '90': 'คะแนน',
      '95': 'จาก',
      '100': 'วันที่ประเมิน',
      '110': 'ประเมินโดย',
      '120': 'สถานะการสัมภาษณ์',
      '130': 'หมายเหตุ',
      '140': 'ความคิดเห็น',
      '150': 'อยู่ระหว่างการสัมภาษณ์',
      '160': 'สัมภาษณ์เรียบร้อยแล้ว'
    },
    'HRMS41EC3': {
      '10': 'เลขที่ใบสมัคร',
      '20': 'ประวัติการเรียกสัมภาษณ์ / ทดสอบ',
      '30': 'ลำดับที่',
      '40': 'เลขที่ใบขออนุมัติ',
      '50': 'ตำแหน่ง',
      '60': 'วันที่สัมภาษณ์',
      '70': 'ผลการพิจารณา',
      '80': 'ประเมินผลโดย',
      '90': 'วันที่ประเมิน'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms41e.js